// Peek-state term definition sheet. Thin wrapper around BottomSheet —
// the cross-cutting behavior (animation, focus, Escape) lives there. We
// only own the visual shell + content. Uses the same definition
// precedence as GlossaryRow: canonical → two-register → bare.

import type { CorpusEntity, PublishedTerm } from "../data/types";
import { resolveTermFamily } from "../reading/termFamily";
import { BottomSheet } from "./BottomSheet";

export interface TermSheetProps {
  entry: PublishedTerm | null;
  canonical?: CorpusEntity | null;
  onClose: () => void;
}

export function TermSheet({ entry, canonical, onClose }: TermSheetProps) {
  if (!entry) {
    return <BottomSheet open={false} variant="peek" onClose={onClose} aria-label="">{null}</BottomSheet>;
  }
  const definition = canonical
    ? canonical.definition.definition_plain
    : entry.definition_obj?.definition_plain ?? entry.definition;
  return (
    <BottomSheet
      open
      variant="peek"
      onClose={onClose}
      aria-label={`Definition: ${entry.term}`}
      termFamily={resolveTermFamily(entry)}
      className="maisight-sheet"
    >
      <button
        type="button"
        className="maisight-sheet-close"
        onClick={onClose}
        aria-label="Close definition"
      >
        ×
      </button>
      <div className="maisight-sheet-term">{entry.term}</div>
      <div className="maisight-sheet-def">{definition}</div>
    </BottomSheet>
  );
}
